module.exports = __webpack_public_path__ + "img/star4green.d3bf2174.png";